// How long to let the OS finish tearing a device down before re-attempting capture (RISKS.md/P2.38).
export const DEVICE_SETTLE_MS = 500

// RISKS.md/P1.26: the `ended` re-capture stops at the cap, backing off from DEVICE_SETTLE_MS; an
// `ended` after a track lived this long starts a fresh count.
export const RECAPTURE_MAX_ATTEMPTS = 3
export const RECAPTURE_STABLE_MS = 10000

// A zero-output reading must HOLD this long to be believed: above a devicechange burst or a headset
// swap transiting zero, below the time a user takes to conclude they hear nothing (RISKS.md/P2.50).
export const SPEAKER_MISSING_CONFIRM_MS = 3000

// The settings panels' own cadence, but scoped to the broken state — the meeting room with the
// sidebar closed polls nothing, leaving retraction to `devicechange` alone (RISKS.md/P2.43, P2.50).
export const SPEAKER_RECOVERY_POLL_MS = 5000

// Top of Material Design's 4-10s snackbar range, which it reserves for long or actionable copy —
// both true here, and all of these are dismissible (WCAG 2.2.1). RISKS.md/P2.38.
export const DEVICE_TOAST_TTL_MS = 10000

// Longer than DEVICE_TOAST_TTL_MS: a test toast is raised while the test still runs, and its copy
// is up to three sentences. Still a ttl, since it reports a finished event (RISKS.md/P2.39).
export const SPEAKER_TEST_TTL_MS = 15000

// A cap, not a target: the take is normally ended early, so this only has to not surprise anyone.
export const MIC_TEST_RECORD_MS = 10000

// Playback runs at most the take's length, plus slack. Fires only on an element that never `ended`.
export const MIC_TEST_PLAYBACK_CAP_MS = MIC_TEST_RECORD_MS + 5000

// Window for collapsing a burst of capture requests into a single capture (RISKS.md/P2.38).
export const CAPTURE_COALESCE_MS = 200

// How long a capture must be in flight before the UI says "starting" (RISKS.md/P2.38). The two cases
// cannot be told apart when they begin, only by how long they last:
//   FRESH — no previous failure. ZERO delay: there is nothing else to put on the tile, and any wait
//     exposes the <video>'s last decoded frame. MIN_LABEL_VISIBLE_MS is what stops it flickering.
//   RETRY — a previous attempt failed, so the device may still be gone and getUserMedia would reject
//     in milliseconds. Wait instead, and let the "no camera" state cover it.
export const FRESH_LABEL_MS = 0
export const RETRY_LABEL_MS = 1000
// Once shown, keep it up this long even if the capture finishes sooner: otherwise a capture just
// over RETRY_LABEL_MS flashes the label, which reads as a glitch (RISKS.md/P2.38).
export const MIN_LABEL_VISIBLE_MS = 800
